// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntd[data-v-1736236c] {\n\tborder-bottom: 2px solid #f9f9f9;\n}\ntd[data-v-1736236c],\nth[data-v-1736236c] {\n\tpadding: 8px 12px 8px 5px;\n\tbackground: white;\n\tfont-size: 13px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
